import { Avatar, ThemeProvider, createTheme, styled } from '@mui/material'
import Box from '@mui/material/Box'
import CssBaseline from '@mui/material/CssBaseline'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ConfirmProvider } from 'material-ui-confirm'
import { SnackbarProvider } from 'notistack'
import { PropsWithChildren } from 'react'

export const Footer = styled('div')`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 1rem;
  display: flex;
  padding: 0.5rem;
  justify-content: center;
`

export const StyledBox = styled(Box)`
  .MuiInputBase-root {
    background-color: #fff;
  }
`

const defaultQueryClient = new QueryClient()
const defaultTheme = createTheme({
  palette: {
    primary: {
      main: '#8B0404',
    },
    secondary: {
      main: '#F8C7C7',
    },
  },
  typography: {
    fontSize: 16,
    fontFamily: '"UTM Aptima", Roboto, Helvetica, Arial',
  },
})

export const DefaultLayout = ({ children }: PropsWithChildren<any>) => {
  return (
    <QueryClientProvider client={defaultQueryClient}>
      <ThemeProvider theme={defaultTheme}>
        <SnackbarProvider anchorOrigin={{ horizontal: 'right', vertical: 'top' }} maxSnack={1}>
          <ConfirmProvider>
            <CssBaseline />
            <StyledBox style={{ minHeight: '100vh' }} display="flex" flexDirection="column">
              <Box>
                <Box flex={1} paddingTop={'1rem'} display={'flex'} justifyContent={'center'}>
                  <Avatar variant="square" sx={{ height: '7rem', width: '7rem' }} src="/assets/logo192.png" />
                </Box>
              </Box>
              <Box flex="1" display="flex" flexDirection="column">
                {children}
              </Box>
              <Footer style={{ textAlign: 'center' }}>
                <span>Copyright ©2024 by Đào Tiên</span>
              </Footer>
            </StyledBox>
          </ConfirmProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </QueryClientProvider>
  )
}
